module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views.gptChats.title":"Cloud Intelligence"}}')
  delete Component.options._Ctor
}
